import React, { FC, SVGProps } from 'react'
import { twMerge } from 'tailwind-merge'

const theme = {
  root: {
    base: 'inline-flex items-center justify-center rounded-lg',
    color: {
      gray: 'bg-gray-100 text-gray-800',
      green: 'bg-green-100 text-green-700',
    },
    size: {
      md: 'h-8 w-8',
      lg: 'h-12 w-12',
    },
  },
  icon: {
    size: {
      md: 'h-5 w-5',
      lg: 'h-6 w-6',
    },
  },
}

interface IconShapesProps {
  icon: FC<Omit<SVGProps<SVGSVGElement>, 'ref'>>
  color?: keyof typeof theme.root.color
  size?: keyof typeof theme.root.size
  className?: string
}

const IconShapes: React.FC<IconShapesProps> = ({
  icon: Icon,
  color = 'gray',
  size = 'md',
  className,
}) => (
  <div
    className={twMerge(
      theme.root.base,
      theme.root.size[size],
      theme.root.color[color],
      className
    )}
  >
    <Icon className={theme.icon.size[size]} />
  </div>
)
export default IconShapes
